import type { ILandingVisit } from "~/feature/attribution/type";
import { toHostname } from "~/feature/attribution/utils/referrerDomain";
import { getPublicSiteOrigin } from "~/utils/getSiteOrigin";

const readOwnHosts = (): string[] => {
  const siteHost = toHostname(getPublicSiteOrigin());
  const pageHost = window.location.hostname;

  return siteHost ? [siteHost, pageHost] : [pageHost];
};

export const readLandingVisit = (now: number): ILandingVisit => ({
  search: window.location.search,
  referrer: document.referrer,
  ownHosts: readOwnHosts(),
  now,
});
